import { useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import { PROJECT_CONTRACTS_QUERY } from "@/hooks/useProjectContracts";
import { PROJECT_FINANCIAL_SUMMARY_QUERY } from "@/hooks/useProjectFinancialSummary";
import type { MutationCallbacks } from "@/hooks/useMarkInstallmentAsPaid";

export const DELETE_CONTRACT_MUTATION = gql`
  mutation DeleteContract($id: ID!) {
    deleteContract(id: $id) {
      contract {
        id
      }
    }
  }
`;

type UseDeleteContractOptions = MutationCallbacks;

export function useDeleteContract(projectId: string, options?: UseDeleteContractOptions) {
  const [mutate, { loading, error }] = useMutation(DELETE_CONTRACT_MUTATION, {
    refetchQueries: [
      { query: PROJECT_CONTRACTS_QUERY, variables: { projectId } },
      { query: PROJECT_FINANCIAL_SUMMARY_QUERY, variables: { projectId } },
    ],
  });

  const deleteContract = (contractId: string, callbacks?: MutationCallbacks) => {
    mutate({
      variables: { id: contractId },
      onCompleted: () => {
        options?.onCompleted?.();
        callbacks?.onCompleted?.();
      },
      onError: (mutationError) => {
        options?.onError?.(mutationError);
        callbacks?.onError?.(mutationError);
      },
    });
  };

  return { deleteContract, loading, error };
}
